import ConstantsUtil from "../../../context/constantsUtil";
import WorkerApiService from "../../workerApiServices";
import GeneralServices from "../generalServices";


class TransactionService extends WorkerApiService {

    constructor() {
        super('/api/transactions')
    }

    searchGroupByProduct(filtro){
        return this.post(`/searchGroupByProduct`, filtro)
    }

    searchByNFUuid(nfUuid, productUuid, productId){
        let params = `?`
        params = `${params}&nfUuid=${nfUuid}`
        
        if(productUuid){
            params = `${params}&productUuid=${productUuid}`
        }

        if(productId){
            params = `${params}&productId=${productId}`
        }
            
        return this.get(`/searchByNFUuid${params}`)
    }

    getTypeList(){
        let list =  [
            {label: 'Selecione...', value: ''},
            {label: 'Entrada', value: ConstantsUtil.tipoNFEntradaLabel},
            // {label: 'Devolução de Entrada', value: ConstantsUtil.tipoNFDevolucaoEntradaLabel},
            {label: 'Saída', value: ConstantsUtil.tipoNFSaidaLabel},
            // {label: 'Devolução de Saída', value: ConstantsUtil.tipoNFDevolucaoSaidaLabel},
        ]

        return list
    }

    getSituationList(){
        let list =  [
            {label: 'Selecione...', value: ''},
            {label: 'Documento Regular', value: ConstantsUtil.situacaoRegular},
            // {label: 'Escrituração Extemporânea de Documento Regular', value: 'Escrituração_extemporânea_de_documento_regular'},
            {label: 'Documento Cancelado', value: 'Documento_cancelado'},
            // {label: 'Escrituração_extemporânea_de_documento_cancelado', value: 'Escrituração_extemporânea_de_documento_cancelado'},
            // {label: 'NFe_NFCe_ou_CTe_denegado', value: 'NFe_NFCe_ou_CTe_denegado'},
            // {label: 'NFe_NFCe_ou_CTe_Numeração_inutilizada', value: 'NFe_NFCe_ou_CTe_Numeração_inutilizada'},
            // {label: 'Documento_Fiscal_Complementar', value: 'Documento_Fiscal_Complementar'},
            // {label: 'Escrituração_extemporânea_de_documento_complementar', value: 'Escrituração_extemporânea_de_documento_complementar'},
            // {label: 'Documento_Fiscal_emitido_com_base_em_Regime_Especial_ou_Norma_Específica', value: 'Documento_Fiscal_emitido_com_base_em_Regime_Especial_ou_Norma_Específica'},
            {label: 'Documento Excluído', value: ConstantsUtil.situacaoExcluida},
        ]

        return list
    }

    getCodeList(list){
        var codigoList = []
        list.forEach(transaction => {
            var codigo = transaction.productInfo.codigo
            var codigoLabel = codigo ? codigo.toString() : null
            if(codigo && !codigoList.some(element => element.value === codigo)){
                var object = {label: codigoLabel, value: codigo}
                codigoList.push(object)
            }
        })
        codigoList.sort( GeneralServices.compareGenericValues );
        return codigoList
    }

    getDescriptionList(list){
        var descriptionList = []
        list.forEach(transaction => {
            var productDescription = transaction.productDescription
            if(!descriptionList.some(element => element.value === productDescription)){
                var object = {label: productDescription, value: productDescription}
                descriptionList.push(object)
            }
        })
        descriptionList.sort( GeneralServices.compareGenericValues );
        return descriptionList
    }

    getNCMList(list){
        var NCMList = []
        list.forEach(transaction => {
            var ncm = transaction.productInfo.ncm
            if(!NCMList.some( element => element.value === ncm )){
                var ncmLabel = ncm !== null ? ncm.toString() : null
                if(ncmLabel === '0') {
                    ncmLabel = '00000000'
                }
                var object = {label: ncmLabel, value: ncm}
                NCMList.push(object)
            }
        })
        NCMList.sort( GeneralServices.compareGenericValues );
        return NCMList
    }

    getCfopList(list){
        var CfopList = []
        list.forEach(transaction => {
            var cfop = transaction.productInfo.cfop
            var cfopLabel = cfop ? cfop.toString() : null
            if(!CfopList.some( element => element.value === cfop )){
                var object = {label: cfopLabel, value: cfop}
                CfopList.push(object)
            }
        })
        CfopList.sort( GeneralServices.compareGenericValues );
        return CfopList
    }

    getNumberList(list){
        var NumberList = []
        list.forEach(transaction => {
            var number = transaction.numero
            var numberLabel = number.toString()
            if(!NumberList.some( element => element.value === number )){
                var object = {label: numberLabel, value: number}
                NumberList.push(object)
            }
        })
        NumberList.sort( GeneralServices.compareGenericValues );
        return NumberList
    }

    getSerieList(list){
        var serieList = []
        list.forEach(transaction => {
            var serie = transaction.serie
            var serieLabel = serie.toString()
            if(!serieList.some( element => element.value === serie )){
                var object = {label: serieLabel, value: serie}
                serieList.push(object)
            }
        })
        serieList.sort( GeneralServices.compareIntValues );
        return serieList
    }

    getModelList(list){
        var modeloList = []
        list.forEach(transaction => {
            var modelo = transaction.modelo
            var modeloLabel = modelo.toString()
            if(!modeloList.some( element => element.value === modelo )){
                var object = {label: modeloLabel, value: modelo}
                modeloList.push(object)
            }
        })
        modeloList.sort( GeneralServices.compareIntValues );
        return modeloList
    }

    getUnitList(list){
        var unitList = []
        list.forEach(transaction => {
            var info = transaction.productInfo
            if(!unitList.some( element => element.value === info.unidadeComercializada )){
                var object = {label: info.unidadeComercializada, value: info.unidadeComercializada}
                unitList.push(object)
            }
        })
        unitList.sort( GeneralServices.compareGenericValues );
        return unitList
    }

    deleteMultipleTransactions(object){
        return this.post(`/deleteMultipleTransactions`, object)
    }

    deleteMultipleNFs(object){
        return this.post(`/deleteMultipleNFs`, object)
    }

    getRelatorioInflacao(dataInicial, dataFinal){
        let params = `?`
        params = `${params}&dataInicial=${dataInicial}`
        params = `${params}&dataFinal=${dataFinal}`
        return this.get(`/getRelatorioInflacao${params}`)
    }

    getLancamentosIndividuais(dataInicial, dataFinal, descricaoProdutosFiltradosList){
        let params = `?`
        params = `${params}&dataInicial=${dataInicial}`
        params = `${params}&dataFinal=${dataFinal}`
        return this.post(`/getLancamentosIndividuais${params}`, descricaoProdutosFiltradosList)
    }    

    
}

export default TransactionService